module.exports = __webpack_public_path__ + "assets/img/recordIcon1.bf595f60.png";